<template>
  <component
    :is="iconSvg"
    :key="icon"
    aria-hidden="true"
    :class="[$style.icon, { [$style.mirrorX]: mirrorX, [$style.mirrorY]: mirrorY }]"
    :style="color ? { '--sca-icon-color': color, color } : undefined"
  />
</template>
<script setup lang="ts">
import { computed } from "vue";

import type { IconName } from "./icons/iconNames.generated";
import { resolveIcon } from "./icons/resolveIcon";

const props = withDefaults(
  defineProps<{
    size?: string;
    icon: IconName;
    mirrorX?: boolean;
    mirrorY?: boolean;
    /** A fixed colour: neither a container nor a hover colour overrides it. */
    color?: string;
  }>(),
  {
    size: "20px",
    mirrorX: false,
    mirrorY: false,
    color: undefined,
  },
);

const size = computed(() => props.size);

const iconSvg = computed(() => resolveIcon(props.icon));

defineOptions({
  name: "SCASvgIcon",
});
</script>

<style lang="scss" module>
@use "../styles/customColors.scss";

.icon {
  --size: v-bind(size);

  width: var(--size);
  height: var(--size);
  display: inline-block;
  flex-shrink: 0;
  flex-grow: 0;

  color: var(--sca-icon-color, var(--color-semantic-neutral-m1));

  &.mirrorX {
    transform: scaleX(-1);
  }
  &.mirrorY {
    transform: scaleY(-1);
  }
  &.mirrorX.mirrorY {
    transform: scale(-1, -1);
  }
}
</style>
